import {
  AUDIO_THEN_VIDEO_FLAG_CAMEL_KEY,
  setAudioThenVideoEnabled,
} from '@src/utility/audioThenVideoFlag';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

/**
 * Mirrors the `story-upload-ttfe-audio-then-video` LaunchDarkly flag into the
 * module-level switch the readiness predicates read (they run in stores and
 * services, outside React). Mount once at the app root, under the LD provider.
 *
 * Only a payload that actually carries the key is mirrored. The LD context key
 * embeds the storyId (`useLaunchDarklyInit`), so every story navigation
 * re-identifies and re-evaluates; mid-flight `useFlags()` returns a payload
 * without this key. Mirroring that gap would read as "not true" and force the
 * switch off mid-session, taking the feature away from a user mid-edit even
 * though nobody turned it off. A flag LaunchDarkly never serves at all leaves
 * the module at its documented default (off).
 */
export function useAudioThenVideoFlagSync(): void {
  const flags = useFlags();
  const isServed = AUDIO_THEN_VIDEO_FLAG_CAMEL_KEY in flags;
  const value = flags[AUDIO_THEN_VIDEO_FLAG_CAMEL_KEY];
  useEffect(() => {
    if (!isServed) return;
    setAudioThenVideoEnabled(value);
  }, [isServed, value]);
}
